import { Attachment, Translations, UUID } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import { Asset } from './AssetApi';
import { AttributeValue } from './AttributeValueApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export interface ProductVariation extends BaseEntity {
	code: string;
	name: string;
	attributeValues: AttributeValue[];
	pricePerMeter: number;
	maxLength: number;
}

export interface Product extends BaseEntity {
	code: string;
	name: string;
	description: string;
	image?: Attachment;
	model3d?: Asset;
	defaultVariation?: ProductVariation;
	attributeValues: AttributeValue[];
	translations: Translations<{
		name: string;
	}>;
}

class ProductApi extends EntityApi<Product> {
	constructor() {
		super(QueryKey.products);

		this.initialize = this.initialize.bind(this);
	}

	async initialize(id: UUID) {
		const product = await super.mutationGetOne(id);

		const response = await httpClient.get<ProductVariation[]>(
			`${this.queryKey}/${product.id}/variations`,
			{
				params: {
					limit: -1,
				},
			}
		);

		return { product, variations: response.data };
	}
}

export default new ProductApi();
